/* eslint-disable */
import mutations from './mutations'
import actions from './actions'

export default {
  state: {
    leaveData: null
  },
  mutations,
  actions,
};
